import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { useLanguage } from './LanguageContext';
interface SlideChapterIntroProps {
  onContinue: () => void;
  number: string; // e.g. "01"
  name: string; // e.g. "The Opportunity"
  description?: string;
  topics?: string[];
  nextLabel: string;
}
export function SlideChapterIntro({
  onContinue,
  number,
  name,
  nextLabel
}: SlideChapterIntroProps) {
  const {
    t
  } = useLanguage();
  const [stage, setStage] = useState(0);
  useEffect(() => {
    const t1 = setTimeout(() => setStage(1), 200);
    const t2 = setTimeout(() => setStage(2), 800);
    return () => {
      ;
      [t1, t2].forEach(clearTimeout);
    };
  }, []);
  return <div className="h-full w-full flex flex-col items-center justify-center px-12 py-16 relative overflow-hidden" data-id="element-229">
      {/* Background mega-numeral */}
      <motion.div initial={{
      opacity: 0,
      x: -40
    }} animate={{
      opacity: stage >= 1 ? 0.05 : 0,
      x: stage >= 1 ? 0 : -40
    }} transition={{
      duration: 1
    }} className="pointer-events-none absolute inset-0 flex items-center justify-center" data-id="element-230">
        <span className="text-[40vw] md:text-[32vw] font-serif font-bold leading-none text-teal-400 select-none" data-id="element-231">
          {number}
        </span>
      </motion.div>

      <div className="relative z-10 max-w-5xl w-full" data-id="element-232">
        {/* Chapter eyebrow */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: stage >= 1 ? 1 : 0,
        y: stage >= 1 ? 0 : 10
      }} transition={{
        duration: 0.6
      }} className="flex items-center gap-4" data-id="element-233">
          <span className="text-teal-400 text-sm font-bold uppercase tracking-[0.3em]" data-id="element-234">
            {t('Chapter', 'Kapitel')} {number}
          </span>
          <span className="flex-1 h-px bg-teal-400/30" data-id="element-235" />
        </motion.div>

        {/* Title */}
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: stage >= 1 ? 1 : 0,
        y: stage >= 1 ? 0 : 20
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="text-6xl md:text-8xl font-serif font-bold text-white tracking-tight leading-none mt-4" data-id="element-236">
          {name}
        </motion.h2>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: stage >= 2 ? 1 : 0
      }} transition={{
        duration: 0.5
      }} className="mt-16 flex justify-end" data-id="element-237">
          <Button onClick={onContinue} className="px-7 py-3 text-base" data-id="element-238">
            {nextLabel}
          </Button>
        </motion.div>
      </div>
    </div>;
}